import { combineReducers } from 'redux';
import { Endpoint, Line, Call, Settings } from '../../model';
import { Actions, StoreState } from '../types';
import { getType } from 'typesafe-actions';
import * as actions from '../actions';
import devices from './devices'

function endpoint(state: Endpoint = { canConnect: false, canDisconnect: false, status: 'offline' }, action: Actions): Endpoint {
  switch (action.type) {
    case getType(actions.endpointStatusChanged):
      return action.payload
  }

  return state
}

function line(state: Line = { canRegister: false, canUnregister: false, status: 'unregistered' }, action: Actions): Line {
  switch (action.type) {
    case getType(actions.endpointStatusChanged):
      if (action.payload.status === 'offline') {
        return { canRegister: false, canUnregister: false, status: 'unregistered' }
      } else {
        return state
      }
    case getType(actions.lineStatusChanged):
      return action.payload
  }

  return state
}

// defaulted values so that the ui doesn't have to null check
const noCalls: Call[] = [
  {
    callId: '',
    status: 'idle',
    // statusError?: string
    // localStream?: MediaStream
    // remoteStream?: MediaStream

    peerUsername: '',
    peerDisplayName: '',

    canDial: false,
    canRingOut: false,
    canHangUp: false,
    canAnswer: false,
    answerRequested: false,
    featureHoldResume: false,
    canHold: false,
    canResume: false,
    canBlindXfer: false,
    canXfer: false,
    canSendDtmf: false,
    isMuted: false,
    hasRemoteVideo: false,
    hasLocalVideo: false,
    videoSource: undefined,

    canPlayBusyTone: false,
    canPlayReorderTone: false,
    canPlayNuTone: false,
    lastHangupCode: 0,

    isSlowAudioDownlink: false,
    isSlowAudioUplink: false,
    isScreenSharing: () => false,
  },
  {
    callId: '',
    status: 'idle',
    // statusError?: string
    // localStream?: MediaStream
    // remoteStream?: MediaStream

    peerUsername: '',
    peerDisplayName: '',

    canDial: false,
    canRingOut: false,
    canHangUp: false,
    canAnswer: false,
    answerRequested: false,
    featureHoldResume: false,
    canHold: false,
    canResume: false,
    canBlindXfer: false,
    canXfer: false,
    canSendDtmf: false,
    isMuted: false,
    hasRemoteVideo: false,
    hasLocalVideo: false,
    videoSource: undefined,

    canPlayBusyTone: false,
    canPlayReorderTone: false,
    canPlayNuTone: false,
    lastHangupCode: 0,

    isSlowAudioDownlink: false,
    isSlowAudioUplink: false,
    isScreenSharing: () => false,
  },
]

function calls(state: { focusCallIndex: number, calls: Call[] } = { focusCallIndex: 0, calls: [...noCalls] }, action: Actions): { focusCallIndex: number, calls: Call[] } {
  switch (action.type) {
    case getType(actions.endpointStatusChanged):
      if (action.payload.status === 'offline') {
        return { focusCallIndex: 0, calls: [...noCalls] }
      } else {
        return state
      }
    case getType(actions.callStatusChanged):
      return action.payload
  }

  return state
}

const empty = {
  sipDomain: undefined,
  turnServer: '',
  turnServerUdpPort: '3478',
  turnServerTcpPort: '3478',
  janus: '',
} as Settings

function settings(state: Settings = empty, action: Actions): Settings {
  switch (action.type) {
    case getType(actions.configureEndpoint):
      return action.payload
  }

  return state
}

function mediaConstraint(state: MediaTrackConstraintSet = {
  autoGainControl: true,
  echoCancellation: true,
  noiseSuppression: true,
  sampleRate: 16000,
  sampleSize: 16,
  channelCount: 1,
}, action: Actions): MediaTrackConstraintSet {
  switch (action.type) {
    case getType(actions.configureMediaConstraints):
      return action.payload
  }
  return state;
}

export default combineReducers({
  mediaConstraint,
  endpoint,
  line,
  calls,
  settings,
  devices,
})

function getRoot(state: StoreState) { return state.janus }

export function selectEndpoint(state: StoreState) {
  return getRoot(state).endpoint
}

export function selectLine(state: StoreState) {
  return getRoot(state).line
}

export function selectCall(state: StoreState): Call {
  const root = getRoot(state).calls
  return root.calls[root.focusCallIndex]
}

export function selectSettings(state: StoreState) {
  return getRoot(state).settings
}
